/* eslint-disable react/require-default-props */
import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import type { User } from '@/interfaces';

import * as styles from './CompanyUsersTable.css';

type CompanyUsersTableProps = {
  columns: any[];
  data: User[];
  isLoading: boolean;
  isRefetching: boolean;
  isManager?: boolean;
};

export default function CompanyUsersTable({
  columns,
  data,
  isLoading,
  isRefetching,
  isManager = false,
}: CompanyUsersTableProps) {
  const { t } = useTranslation();

  // Manager doesn't have tabs, so table can be taller
  const tableHeight = isManager ? 'calc(50vh - 150px)' : 'calc(50vh - 175px)';

  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        <TradingDatagrid
          tableHeight={tableHeight}
          columnsTable={columns}
          dataTable={data}
          flexLayout
          keepSelectedRowsOnPageChange={false}
          columnOrder={[]}
          stickyColumns={{
            name: 'left',
            edit: 'right',
            delete: 'right',
          }}
          isLoadingMore={isRefetching || isLoading}
          noDataMessage={isRefetching || isLoading ? '' : t('settings.companyDetailsTab.companyUsers.emptyMessage')}
        />
      </div>
    </TradingPanel>
  );
}
